'use client';

import { useRouter } from 'next/navigation';
import { useCallback, useEffect } from 'react';
import { useCurrentPath } from 'src/hooks/useCurrentPath';
import { useAppDispatch, useAppSelector } from 'src/store/client/config';
import type { UserAuth } from 'src/store/client/slices/userSlice';
import { userActions } from 'src/store/client/slices/userSlice';
import userThunk from 'src/store/client/thunks/userThunk';
import customStorage from 'src/utils/storage';
import { momentTimezone } from 'src/utils/time';
import utils from 'src/utils/utils';

export default function PublicAuthProvider({ children }: { children: React.ReactNode }) {
  const router = useRouter();
  const currentPath = useCurrentPath();
  const dispatch = useAppDispatch();

  const { LoggedIn: isLoggedIn, userInfo } = useAppSelector((state) => state.user);

  // 인증 처리 ( 로그인 세션 관리 )
  const authCheck = useCallback(() => {
    const userString = customStorage.getItem('user');

    if (userString && typeof userString === 'string') {
      const user = utils.jsonParse(userString) as UserAuth;
      if (user && user?.expired) {
        const expired = momentTimezone(user.expired);
        const time = expired.diff(momentTimezone(), 'seconds', true);
        if (time >= 60) {
          // 만료 1분전
          dispatch(userActions.login(user));
        } else if (time > -60 && time < 60) {
          // 만료 1분전 - 1분후까지
          dispatch(userThunk.refreshTokenAll());
        } else {
          // 로그아웃
          router.push(`/account/logout?retUrl=${currentPath}`);
          return;
        }
      }
    }
  }, [dispatch, router, currentPath]);

  useEffect(() => {
    if (isLoggedIn) {
      if (!userInfo) {
        dispatch(userThunk.myDataLoad());
      }
    } else {
      authCheck();
    }
  }, [router, authCheck, dispatch, isLoggedIn, userInfo]);

  return <>{children}</>;
}
